import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import NotificationBadge from '../common/NotificationBadge';
import { formatSemesterLabel } from '../../utils/dateFormatter';

export default function SemesterFilter({ semesters, selectedSemesterId, onSemesterChange, unviewedCounts = {} }) {
  const { t } = useTranslation('planner');
  if (!semesters || semesters.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 mb-4">
      <Calendar className="w-4 h-4 text-gray-500 dark:text-gray-400" />
      <div className="flex gap-2">
        {semesters.map((semester) => (
          <button
            key={semester.id}
            onClick={() => onSemesterChange(semester.id)}
            className={`relative px-3 py-1.5 text-sm font-medium rounded-full transition-colors ${
              selectedSemesterId === semester.id
                ? 'bg-[#589DD5] text-white'
                : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
            }`}
          >
            {formatSemesterLabel(semester.label)}
            {semester.type === 'current' && (
              <span className="ml-1 text-xs opacity-75">{t('semester.current')}</span>
            )}
            <NotificationBadge
              count={unviewedCounts[semester.id]}
              size="xs"
              className="absolute -top-1.5 -right-1.5"
            />
          </button>
        ))}
      </div>
    </div>
  );
}
